import bfn from "../assets/bfn.png";
import parkpals from "../assets/parkpals.png";
import algo from "../assets/algo.png";
import yso from "../assets/yso.png";
import alynx from "../assets/alynx.png";

export const ProjectList = [
  {
    name: "Yso Dirty",
    image: yso,
    skills:
      "React Native, Expo, TypeScript, NativeWind, Go (Gin), PostgreSQL, AWS RDS, AWS S3, Redis, WebSockets, Stripe, Checkr, Twilio, AWS SES, GitHub Actions, Docker, AWS Lambda, AWS EC2, AWS ECR, AWS EKS, Route53, REST API, CI/CD",
    link: "https://ysodirty.io",
  },
  {
    name: "Alynx",
    image: alynx,
    skills:
      "NLP, ML, DL, Text Gen, Text Class, NER, Sent Analysis, Knowledge Rep, Data Prep, Model Deploy, API Dev, Scalability, Error Handling, CI/CD, Privacy, UX Design, Version Control, Documentation, Perf Optimization, Monitoring",
    link: "https://alynx.ucmerced.edu",
  },
  {
    name: "AlgoNinja",
    image: algo,
    skills:
      "SwiftUI, MongoDB, NodeJS, Express, AWS EC2, AWS S3, JWT, RestAPI, Dynamic Programming, UI/UX design, Version control systems",
    link: "https://apps.apple.com/us/app/algoninja/id6639586961",
  },
  {
    name: "ParkPals",
    image: parkpals,
    skills:
      "SwiftUI, MongoDB, NodeJS, Express, AWS EC2, AWS S3, JWT, RestAPI, Dynamic Programming, UI/UX design, Version control systems",
    link: "https://apps.apple.com/us/app/parkpals/id6479857155",
  },
  {
    name: "Best Friends Network",
    image: bfn,
    skills:
      "SwiftUI, DynamoDB, Golang, Kubernetes, Docker, Redis, AWS EKS, AWS ECR, AWS S3, JWT, RestAPI, Websockets, AWS Lambda, Google Cloud, Apple Push Notifications, Dynamic Programming, UI/UX design, Version control systems",
    link: "https://apps.apple.com/us/app/best-friends-network/id1573517037",
  },
  
];
